/**
 * Type of ingredients.
 */
export type FruitWineIngredientType =
  | 'BLUEBERRY'
  | 'APPLE'
  | 'BANANA'
  | 'APRICOT'
  | 'GOOSEBERRY'
  | 'QUINCE'
  | 'QUINCE_PEAR'
  | 'ELDERBERRY'
  | 'CHERRY'
  | 'PERSIMMON'
  | 'WOOD_STRAWBERRY'
  | 'BLACKCURRANTS'
  | 'HAWTHORN'
  | 'CHESTNUT'
  | 'SLOE'
  | 'PEAR'
  | 'RASPBERRY'
  | 'SOUR_CHERRY'
  | 'ORANGE'
  | 'PEACH'
  | 'STRAWBERRY'
  | 'BLACKBERRY'
  | 'GRAPE'
  | 'OTHER';

export const FruitWineIngredientType = {
  Blueberry: 'BLUEBERRY' as FruitWineIngredientType,
  Apple: 'APPLE' as FruitWineIngredientType,
  Banana: 'BANANA' as FruitWineIngredientType,
  Apricot: 'APRICOT' as FruitWineIngredientType,
  Gooseberry: 'GOOSEBERRY' as FruitWineIngredientType,
  Quince: 'QUINCE' as FruitWineIngredientType,
  Quince_pear: 'QUINCE_PEAR' as FruitWineIngredientType,
  Elderberry: 'ELDERBERRY' as FruitWineIngredientType,
  Cherry: 'CHERRY' as FruitWineIngredientType,
  Persimmon: 'PERSIMMON' as FruitWineIngredientType,
  Wood_strawberry: 'WOOD_STRAWBERRY' as FruitWineIngredientType,
  Blackcurrants: 'BLACKCURRANTS' as FruitWineIngredientType,
  Hawthorn: 'HAWTHORN' as FruitWineIngredientType,
  Chestnut: 'CHESTNUT' as FruitWineIngredientType,
  Sloe: 'SLOE' as FruitWineIngredientType,
  Pear: 'PEAR' as FruitWineIngredientType,
  Raspberry: 'RASPBERRY' as FruitWineIngredientType,
  Sour_cherry: 'SOUR_CHERRY' as FruitWineIngredientType,
  Orange: 'ORANGE' as FruitWineIngredientType,
  Peach: 'PEACH' as FruitWineIngredientType,
  Strawberry: 'STRAWBERRY' as FruitWineIngredientType,
  Blackberry: 'BLACKBERRY' as FruitWineIngredientType,
  Grape: 'GRAPE' as FruitWineIngredientType,
  Other: 'OTHER' as FruitWineIngredientType,
};
